// extracted by mini-css-extract-plugin
module.exports = {"clock":"Clock_clock__2Z_HF","clockContent":"Clock_clockContent__1DjaX"};